var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: _vm.contentUrl + _vm.articleOfDay.image, alt: "" }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("h3", [_vm._v(_vm._s(_vm.articleOfDay.title))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.articleOfDay.readTime))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card__action",
          on: {
            click: function($event) {
              return _vm.$router.push(
                "/profile/articles#article" + _vm.articleId
              )
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("profile.home.readArticle")) + "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }